import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Box } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { isAdmin } from "../../../../../utils/constants";
import { updateBoard } from "../../../../../services/apiBoards";
import useToastPromise from "../../../../../hooks/useToast";
import { RFHTextField } from "../../../../../components/RFH";
import useBoardIdByKey from "../../../../../hooks/useBoardIdByKey";

function UpdateName({ board }) {
  const { id } = useBoardIdByKey();
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const { showToastPromise } = useToastPromise();

  const { handleSubmit, setValue, ...methods } = useForm({
    defaultValues: {
      board_name: board?.board_name || "",
    },
  });

  useEffect(() => {
    setValue("board_name", board?.board_name || "");
  }, [board?.board_name, setValue]);

  const { mutate } = useMutation({
    mutationFn: async (data) => {
      return await showToastPromise(updateBoard, data);
    },
    onSuccess: (res) => {

      queryClient.invalidateQueries({
        queryKey: ["boards"],
        exact: true
      });
      queryClient.invalidateQueries({
        queryKey: ["boardName", id],
      });
    },
    onError: (error) => {
      console.error("Error Delete Attachments", error);
    },
  });

  const submit = (data) => {
    setOpen(false);
    if (data.board_name != board?.board_name) {
      mutate({ data, board_id: id });
    }
  };

  const openField = () => {
    if (board?.is_owner || isAdmin()) setOpen(true);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit(submit)();
    }
  };
  // console.log("getValues", formState);
  return (
    <>
      {open ? (
        <>
          <FormProvider {...methods}>
            <Box
              component="form"
              onSubmit={handleSubmit(submit)}
              noValidate
              className="board-field-name"
              onBlur={handleSubmit(submit)}
              onKeyDown={handleKeyDown}
            >
              <RFHTextField
                name="board_name"
                required
                fullWidth
                size="small"
                id="board_name"
                autoFocus
                defaultPadding={false}
              />
            </Box>
          </FormProvider>
        </>
      ) : (
        <p className="board-heading-name" onClick={openField}>
          {board?.board_name}
        </p>
      )}
    </>
  );
}

export default UpdateName;
